export default __webpack_public_path__ + "static/game-image-3-eng-3fc5d7277a158e7e44bd16225cc244ee.png";